import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { useState, Fragment } from 'react';
import { IconContainer, CollapsibleContent } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ListItem } from '../styled.js';

function CollapsibleListItem(props) {
  var target = props.target,
    children = props.children,
    className = props.className,
    _props$initiallyOpen = props.initiallyOpen,
    initiallyOpen = _props$initiallyOpen === void 0 ? false : _props$initiallyOpen;
  var _useState = useState(initiallyOpen),
    open = _useState[0],
    setOpen = _useState[1];
  var toggle = function toggle() {
    return setOpen(!open);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(ListItem, {
      onClick: toggle,
      className: className,
      children: [target, /*#__PURE__*/jsx(IconContainer, {
        children: open ? /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
          icon: faChevronUp
        }) : /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
          icon: faChevronDown
        })
      })]
    }), /*#__PURE__*/jsx(CollapsibleContent, {
      $open: open,
      children: children
    })]
  });
}

export { CollapsibleListItem };
